export default __webpack_public_path__ + "static/media/createSegment.11e00864.png";